module.exports = __webpack_public_path__ + "img/skill-linux.76aa55d2.png";